import { FramedIcon } from '@heidi/design-system/framed-icon';
import { TypographyCaption, TypographyPBold } from '@heidi/design-system/typography';
import { Inbox } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export const NotificationsEmpty = () => (
  <div className="flex flex-col items-center gap-4 px-10 pb-8 pt-4">
    <FramedIcon state="neutral" size="lg" icon={<Inbox />} />
    <div className="flex flex-col gap-1 text-center">
      <TypographyPBold>
        <FormattedMessage defaultMessage="Nothing to see here" id="hMVxZsKxxj" />
      </TypographyPBold>
      <TypographyCaption className="text-text-secondary">
        <FormattedMessage
          defaultMessage="No more notifications, you’re free to focus on patient care."
          id="dlbccasFWl"
        />
      </TypographyCaption>
    </div>
  </div>
);
